import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OrderDatesModel } from '../models/order-dates.model';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ScheduledCartService {
    constructor(
        private httpClient: HttpClient
    ){}

    getOrderDates(menuItemId: number): Promise<OrderDatesModel[]> {
        return new Promise((resolve, reject) => {
            this.httpClient.get<OrderDatesModel[]>(environment.exApiURL + '/order_date_selector/' + menuItemId).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (error) => {
                    reject(error);
                }
            });
        });
    }
}
